import axios from "axios";
import { ApiResponse } from "@api/apiRequest";
import { paymentGatewayApi } from "@api/instances";
import { TransactionsResponse } from "@appTypes/index";
import rollbar, { LogMetadata } from "@utils/rollbar";

const getTransactions = async (signal?: AbortSignal): Promise<ApiResponse<TransactionsResponse>> => {
  try {
    const response = await paymentGatewayApi.get<TransactionsResponse>(
      "/v1/billing/payments",
      { signal, requireAuth: true }
    );
    return { data: response.data, success: true, error: "" };
  } catch (e) {
    if (axios.isCancel(e)) {
      return { data: null, success: false, error: "AbortError" };
    }
    const err = e instanceof Error ? e : new Error("Unknown error");
    const meta: LogMetadata = { endpoint: "/v1/billing/payments", method: "GET" };
    rollbar.error(err, meta);
    return { data: null, success: false, error: "Error fetching transactions" };
  }
};

export default getTransactions;
